import type { FactoryEdit } from '@indutrust/factory-model';
import { createCrudEvents } from '@indutrust/shared-util';

/**
 * Events for CRUD operations on the platform-wide factories collection
 * scoped to admin surfaces (the directory at `/backoffice/factories`
 * and the verification queue at `/backoffice/factories/pending`).
 *
 * Mirrors {@link import('../company-factory/+state/company-factories.events').companyFactoriesCrudEvents}
 * but reads from `${api}/factories` instead of the company-scoped
 * collection — admin tooling needs to see factories across companies,
 * starting with everything in `status: 'pending'`.
 *
 * Uses `factory.admin-factories` as the event source namespace for
 * Redux DevTools debugging.
 *
 * @example
 * const dispatch = injectDispatch(adminFactoriesCrudEvents);
 * dispatch.loadAllRequested({});
 */
export const adminFactoriesCrudEvents =
  createCrudEvents<FactoryEdit>('admin-factories');
